<script setup>
import '/node_modules/flag-icons/css/flag-icons.min.css'

import AppLogo from 'components/UI/AppLogo.vue'
import { isCordovaAndroid } from 'src/utils/utils.js'
import { useAuthStore } from 'stores/authStore'
import { useUserStore } from 'stores/userStore'

const authStore = useAuthStore()
const userStore = useUserStore()
const router = useRouter()

const { user } = storeToRefs(userStore)
const { ecdSettings } = storeToRefs(authStore)

const { locale } = useI18n({ useScope: 'global' })
watch(
  user,
  () => {
    if (user.value && user.value.locale) locale.value = user.value.locale
  },
  {
    deep: true,
    immediate: true,
  },
)

watch(
  () => ecdSettings.value?.ENABLE_APP_SECURITY_FLAG,
  (newValue) => {
    if (isCordovaAndroid()) {
      if (newValue !== false) {
        document.addEventListener('deviceready', async () => {
          // Disable means ENABLE protection
          window.plugins.preventscreenshot.disable()
        })
      } else {
        document.addEventListener('deviceready', async () => {
          // Enable means DISABLE protection
          window.plugins.preventscreenshot.enable()
        })
      }
    }
  },
  {
    immediate: true,
  },
)

onMounted(async () => {
  await authStore.loadEcdSettings()

  if (isCordovaAndroid()) {
    document.addEventListener('deviceready', async () => {
      window.open = cordova.InAppBrowser.open
    })
  }
})

defineComponent({
  name: 'App',
})
</script>

<template>
  <q-layout v-if="ecdSettings?.isFailed" view="hHh lpR fFf">
    <q-page-container>
      <q-page class="flex fullscreen bg-grey-2">
        <div class="full-width row flex-center">
          <q-card bordered flat class="col-11 col-sm-10 col-md-6 col-lg-4 shadow-2 rounded-borders">
            <q-card-section class="q-pa-xl">
              <div class="full-width row wrap justify-center items-center content-center">
                <app-logo :mobile="$q.screen.lt.md" />
              </div>
              <div class="q-pt-lg col-10 col-md-6 col-lg-4">
                <div class="col-12 text-center" v-html="$t('Globals.Errors.Loading app')"></div>
                <div class="col column items-center q-mt-md">
                  <q-btn
                    color="primary"
                    @click="authStore.loadEcdSettings(true)"
                    class="q-mt-sm full-width text-bigger"
                    :disabled="!ecdSettings?.isLoaded"
                    :label="$t('Globals.Try again')"
                  />
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
  <router-view v-else-if="ecdSettings?.isLoaded" />
  <q-layout v-else-if="isCordovaAndroid()" view="hHh lpR fFf">
    <q-page-container>
      <q-page class="flex fullscreen bg-grey-2 q-px-sm">
        <div class="full-width q-pa-none row flex-center">
          <q-card bordered flat class="col-11 col-sm-10 col-md-6 col-lg-4 shadow-2 rounded-borders">
            <q-card-section class="q-pa-xl">
              <div class="full-width row wrap justify-center items-center content-center">
                <app-logo :mobile="$q.screen.lt.md" />
              </div>
              <div class="q-pt-lg col-10 col-md-6 col-lg-4">
                <div class="row">
                  <div class="col-12 q-mb-lg text-center" v-html="$t('Globals.Loading')"></div>
                  <div class="col-12 flex justify-center">
                    <q-spinner class="q-mx-auto" color="primary" size="4em" />
                  </div>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
